import { defineComponent, useSlots, computed, openBlock, createBlock, Teleport, createVNode, Transition, withCtx, createElementBlock, withModifiers, normalizeStyle, createElementVNode, normalizeClass, renderSlot, unref, createTextVNode, toDisplayString, createCommentVNode } from "vue";
import InformationCircleStrokeRoundedIcon from "../../assets/icons/outline/information-circle-stroke-rounded.svg.js";
import Button from "../button/Button.vue.js";
const _hoisted_1 = { class: "modal__icons" };
const _hoisted_2 = {
  key: 1,
  class: "modal__title"
};
const _hoisted_3 = { class: "modal__text-section" };
const _hoisted_4 = {
  key: 0,
  class: "modal__title"
};
const _hoisted_5 = {
  key: 1,
  class: "modal__supporting-text"
};
const _hoisted_6 = {
  key: 2,
  class: "modal__content-area"
};
const _hoisted_7 = {
  key: 0,
  class: "modal__actions"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Modal",
  props: {
    modelValue: { type: Boolean, default: false },
    size: { default: "xs" },
    type: { default: "text" },
    variant: { default: "neutral" },
    zIndex: { default: 1001 },
    iconRounded: { default: "2xl" },
    title: {},
    supportingText: {},
    confirmText: { default: "Confirm" },
    cancelText: { default: "Cancel" },
    noIcon: { type: Boolean, default: false },
    closable: { type: Boolean, default: true },
    closeOnBackdrop: { type: Boolean, default: true },
    btnFullWidth: { type: Boolean, default: false },
    confirmDisabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    modalClass: {}
  },
  emits: ["update:modelValue", "close", "cancel", "confirm"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const slots = useSlots();
    const handleClose = () => {
      model.value = false;
      emit("close");
    };
    const handleBackdropClick = () => {
      if (props.closeOnBackdrop) {
        handleClose();
      }
    };
    const handleCancel = () => {
      emit("cancel");
      handleClose();
    };
    const handleConfirm = () => {
      emit("confirm");
    };
    const model = computed({
      get: () => props.modelValue,
      set: (value) => emit("update:modelValue", value)
    });
    const iconWrapperClass = computed(() => {
      const variantMap = {
        neutral: "modal__icon-wrapper--neutral",
        info: "modal__icon-wrapper--info",
        success: "modal__icon-wrapper--success",
        warning: "modal__icon-wrapper--warning",
        danger: "modal__icon-wrapper--danger",
        update: "modal__icon-wrapper--update"
      };
      return variantMap[props.variant];
    });
    const iconClass = computed(() => {
      const variantMap = {
        neutral: "modal__icon--neutral",
        info: "modal__icon--info",
        success: "modal__icon--success",
        warning: "modal__icon--warning",
        danger: "modal__icon--danger",
        update: "modal__icon--update"
      };
      return variantMap[props.variant];
    });
    const hasFooterContent = computed(() => {
      return Boolean(slots.footer) || Boolean(slots.actions) || Boolean(props.cancelText) || Boolean(props.confirmText);
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Teleport, { to: "body" }, [
        createVNode(Transition, {
          "enter-active-class": "modal__transition-enter-active",
          "enter-from-class": "modal__transition-enter-from",
          "enter-to-class": "modal__transition-enter-to",
          "leave-active-class": "modal__transition-leave-active",
          "leave-from-class": "modal__transition-leave-from",
          "leave-to-class": "modal__transition-leave-to"
        }, {
          default: withCtx(() => [
            __props.modelValue ? (openBlock(), createElementBlock("div", {
              key: 0,
              class: "modal__overlay",
              style: normalizeStyle({ zIndex: __props.zIndex }),
              onClick: withModifiers(handleBackdropClick, ["self"])
            }, [
              createElementVNode("div", {
                class: normalizeClass(["modal", [`modal--${__props.size}`, `modal--${__props.type}`, __props.modalClass]]),
                role: "dialog",
                "aria-modal": "true",
                onClick: _cache[0] || (_cache[0] = withModifiers(() => {
                }, ["stop"]))
              }, [
                createElementVNode("div", {
                  class: normalizeClass(["modal__content", { "modal__content--with-footer": hasFooterContent.value }])
                }, [
                  createElementVNode("div", _hoisted_1, [
                    !__props.noIcon ? (openBlock(), createElementBlock("div", {
                      key: 0,
                      class: normalizeClass(["modal__icon-wrapper", [iconWrapperClass.value, { "modal__icon-wrapper--full": __props.iconRounded === "full" }]])
                    }, [
                      renderSlot(_ctx.$slots, "icon", {}, () => [
                        createVNode(unref(InformationCircleStrokeRoundedIcon), {
                          class: normalizeClass(["modal__icon", iconClass.value])
                        }, null, 8, ["class"])
                      ], true)
                    ], 2)) : __props.title || _ctx.$slots.title ? (openBlock(), createElementBlock("h4", _hoisted_2, [
                      renderSlot(_ctx.$slots, "title", {}, () => [
                        createTextVNode(toDisplayString(__props.title), 1)
                      ], true)
                    ])) : createCommentVNode("", true),
                    __props.closable ? (openBlock(), createElementBlock("button", {
                      key: 2,
                      class: "modal__close-button",
                      type: "button",
                      "aria-label": "Close modal",
                      onClick: handleClose
                    }, [..._cache[1] || (_cache[1] = [
                      createElementVNode("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        class: "modal__close-icon"
                      }, [
                        createElementVNode("path", {
                          d: "M19 5L5 19M5 5L19 19",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)
                    ])])) : createCommentVNode("", true)
                  ]),
                  createElementVNode("div", _hoisted_3, [
                    (__props.title || _ctx.$slots.title) && !__props.noIcon ? (openBlock(), createElementBlock("h4", _hoisted_4, [
                      renderSlot(_ctx.$slots, "title", {}, () => [
                        createTextVNode(toDisplayString(__props.title), 1)
                      ], true)
                    ])) : createCommentVNode("", true),
                    __props.type === "text" ? (openBlock(), createElementBlock("div", _hoisted_5, [
                      renderSlot(_ctx.$slots, "supporting-text", {}, () => [
                        createTextVNode(toDisplayString(__props.supportingText), 1)
                      ], true)
                    ])) : (openBlock(), createElementBlock("div", _hoisted_6, [
                      renderSlot(_ctx.$slots, "content", {}, void 0, true)
                    ]))
                  ])
                ], 2),
                hasFooterContent.value ? (openBlock(), createElementBlock("div", _hoisted_7, [
                  renderSlot(_ctx.$slots, "footer", {}, () => [
                    renderSlot(_ctx.$slots, "actions", {}, () => [
                      createElementVNode("div", {
                        class: normalizeClass(["modal__actions-content", {
                          "modal__actions-content--full-width": __props.btnFullWidth
                        }])
                      }, [
                        __props.cancelText ? (openBlock(), createBlock(Button, {
                          key: 0,
                          type: "secondary",
                          size: "md",
                          onClick: handleCancel
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(__props.cancelText), 1)
                          ]),
                          _: 1
                        })) : createCommentVNode("", true),
                        __props.confirmText ? (openBlock(), createBlock(Button, {
                          key: 1,
                          type: "primary",
                          size: "md",
                          variant: __props.variant === "danger" ? "destructive" : "default",
                          disabled: __props.confirmDisabled,
                          loading: __props.loading,
                          onClick: handleConfirm
                        }, {
                          default: withCtx(() => [
                            createTextVNode(toDisplayString(__props.confirmText === "Confirm" && __props.variant === "danger" ? "Delete" : __props.confirmText), 1)
                          ]),
                          _: 1
                        }, 8, ["variant", "disabled", "loading"])) : createCommentVNode("", true)
                      ], 2)
                    ], true)
                  ], true)
                ])) : createCommentVNode("", true)
              ], 2)
            ], 4)) : createCommentVNode("", true)
          ]),
          _: 3
        })
      ]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=Modal.vue2.js.map
